import { lazy } from "react";

export { COMPANY_DOCUMENTS_EDIT_PATH } from "./company-documents-edit-path";
export const CompanyDocumentsEditPage = lazy(
  () => import("./company-documents-edit"),
);
